import { render, staticRenderFns } from "./Wallets.vue?vue&type=template&id=539fcf56&scoped=true&"
import script from "./Wallets.vue?vue&type=script&lang=js&"
export * from "./Wallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539fcf56",
  null
  
)

export default component.exports